import { useEffect } from "react";
import { Form } from "react-bootstrap";

export function EntrySelector(props) {
    useEffect(() => {
        if (props.entries && props.entries.length > 0 && props.entry === null) {
            props.setEntry(props.entries[0]);
        }
    }, [props]);

    if (!props.entries || props.entries.length === 0 || props.entry === null) {
        return (<></>)
    }

    const findEntry = (id, entries) => {
        if (!entries) {
            return null;
        }
        return entries.filter((e) => { return e.id === id; })[0];
    }

    return (
        <Form.Select className="w-auto ms-3" id={props.id} onChange={(e) => props.setEntry(findEntry(parseInt(e.target.value), props.entries))} value={props.entry.id}>
            {props.entries.map((e, i) => {
                return <option key={e.id} value={e.id}>{e.name}</option>
            })}
        </Form.Select>
    );
};